import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend'; // Optional: For loading translations from external files

i18n
  .use(Backend) // Optional: for loading translation files from a server or local files
  .use(initReactI18next) // Initializes the i18next-react bindings
  .init({
    fallbackLng: 'en',  // Default language
    lng: 'en',  // Starting language
    interpolation: {
      escapeValue: false, // React escapes values
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to your translations
    },
  });

export default i18n;
